import { type UniversalBenchmarksStage } from "@features/universal-benchmarks/consumer/types";
import {
  type QuickFilter,
  type QuickFilterRevenueConfig,
} from "@north-beam/nb-common";

import { type ChartState, type TableState } from "./types";

export const PLATFORM_BREAKDOWN_ID = "breakdown:Platform (Northbeam)";
export const CATEGORY_BREAKDOWN_ID = "breakdown:Category (Northbeam)";

export const DEFAULT_TABLE_STATE: TableState = {
  selectedTab: "breakdown",
  searchText: "",
  selectedBreakdownId: PLATFORM_BREAKDOWN_ID,
  selectedMetricIds: [],
  metricFilters: [],
  breakdownFilters: [],
  sorting: [],
  breakdownSelection: [],
  campaignSelection: [],
  adsetSelection: [],
  adSelection: [],
  showPercentChange: false,
  pageIndex: 0,
  pageSize: 25,
};

export const DEFAULT_CHART_STATE: ChartState = {
  metrics: [],
  alignAxesScale: false,
  displayMode: "split",
};

export const FALLBACK_QUICK_FILTER: QuickFilter<QuickFilterRevenueConfig> = {
  id: "__fallback__",
  name: "Fallback",
  config: {
    selectedTab: "breakdown",
    chartMetricIds: [],
    alignAxesScale: false,
    accountingMode: "accrual",
    dateRange: "last7Days",
    compareDateRange: { value: "previousPeriod" },
    tableMetricIds: [],
    sorting: [],
    breakdownIds: [PLATFORM_BREAKDOWN_ID],
    breakdownFilters: [],
  },
};

export const STACKED_CHART_SUPPORTED_METRICS = [
  "rev",
  "revFt",
  "revRtn",
  "revLtv",
  "revFtLtv",
  "revRtnLtv",
  "spend",
  "txns",
  "txnsFt",
  "txnsRtn",
  "txnsLtv",
  "txnsFtLtv",
  "txnsRtnLtv",
  "visitors",
  "visitorsFt",
  "visitorsRtn",
  "visitorsFtRtn",
  "customers",
  "customersFt",
  "customersRtn",
  "customersFtRtn",
];

export const UNIVERSAL_BENCHMARKS_STAGE_OPTIONS: {
  value: UniversalBenchmarksStage;
  label: string;
}[] = [
  { value: "blended", label: "Blended" },
  { value: "new", label: "New" },
  { value: "returning", label: "Returning" },
];
